<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <div class="hm-heading">
        <span class="hm-heading__title"><span class="hm-heading__id">{{ account_data.property.name }}</span></span>
        <span class="hm-heading__title">| {{ account_data.account_name }}</span>
        <div class="hm-folio__balance">
          Balance:
          <HMBalance :balance="account_data.balance"/>
        </div>
      </div>
      <div class="hm-gridline">
        <HMButton style="height: 38px" @click.native="onShowModalPayment"><span>Add Payment</span></HMButton>
        <HMButton style="height: 38px" @click.native="onShowModalService" background="linear-gradient(0deg, #FFCDB5 0%, #FBE0D2 100%)" color="#A4744A">
          <span>Add Service</span>
        </HMButton>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            shortcut="last3Days"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
      </div>
      <HMFolioList
        v-if="transactionItems.length"
        @postVoid="onVoidTransaction"
        :transactions="transactionItems"
      />
      <HMSlug v-else style="margin: 0 20px 20px;">
        <template #img><img alt="Services" src="@/assets/img/hm-services.png"/></template>
        <template #title>No services or payments yet</template>
        <template #text>All future services and charges will appear here once added.</template>
      </HMSlug>
    </template>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="payment-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('payment-form')"></button>
        <div class="popup-new__title">Add Payment</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('paymentForm', 'onCreatePayment')">
            <app-form-field :marginBottom="20" class="family" label="Method" required>
              <app-cells :indent="false">
                <app-radio
                  v-for="item in method_options"
                  :key="item.code"
                  v-model="paymentForm.method"
                  :checked="paymentForm.method"
                  :value="item.code"
                  class="family"
                  name="method"
                >
                  <template #label>{{ item.name }}</template>
                </app-radio>
              </app-cells>
              <template #error>
                <div v-if="$v.paymentForm.method.$dirty && !$v.paymentForm.method.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field v-if="paymentForm?.method === 'cash'" :marginBottom="20" label="Currency" required class="family">
              <app-select
                v-model="paymentForm.currency"
                :options="currency_options"
                :clearable="false"
                :reduce="item => item.code"
                placeholder="Currency"
                class="family"
                :error="$v.paymentForm.currency.$error"
              />
              <template #error>
                <div v-if="$v.paymentForm.currency.$dirty && !$v.paymentForm.currency.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Amount" label-for="paymentAmount" required>
              <app-fin-number
                v-model="paymentForm.amount"
                id="paymentAmount"
                name="paymentAmount"
                placeholder="0"
                :error="$v.paymentForm.amount.$error"
              />
              <template #error>
                <div v-if="$v.paymentForm.amount.$dirty && !$v.paymentForm.amount.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="paymentNotes">
              <app-textarea
                v-model="paymentForm.notes"
                id="paymentNotes"
                placeholder="Notes"
                class="family"
              />
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingPaymentForm"><span>Create</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="service-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('service-form')"></button>
        <div class="popup-new__title">Add Service</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('serviceForm', 'onCreateService')">
            <app-form-field :marginBottom="20" label="Category" class="family" required>
              <app-select
                v-model="serviceForm.transaction_category"
                :options="transaction_categories_options"
                :clearable="false"
                placeholder="Category"
                class="family"
                :error="$v.serviceForm.transaction_category.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.transaction_category.$dirty && !$v.serviceForm.transaction_category.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Amount" label-for="serviceAmount" required>
              <app-fin-number
                v-model="serviceForm.amount"
                id="serviceAmount"
                placeholder="0"
                :error="$v.serviceForm.amount.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.amount.$dirty && !$v.serviceForm.amount.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="serviceNotes" :required="serviceForm?.transaction_category?.notes_required">
              <app-textarea
                v-model="serviceForm.notes"
                id="serviceNotes"
                placeholder="Notes"
                class="family"
                :error="$v.serviceForm.notes.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.notes.$dirty && !$v.serviceForm.notes.required">Required field</div>
              </template>
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingServiceForm"><span>Add</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getHotelManagementHouseAccountsV2Detail, getHotelManagementTransactionCategories,
  getHotelManagementTransactions, postHotelManagementPaymentsCreateSingle, postHotelManagementTransactions
} from '@/http'
import HMBalance from '@/views/hotel-management/reservations/components/HMBalance.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import { required, requiredIf } from 'vuelidate/lib/validators'
import HMSlug from '@/views/hotel-management/reservations/components/HMSlug.vue'
import HMFolioList from '@/views/hotel-management/reservations/components/HMFolioList.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import moment from 'moment'

export default {
  name: 'HotelManagementHouseAccountsDetail',
  components: {HMFolioList, HMSlug, HMButton, HMBalance, VueCtkDateTimePicker},
  data() {
    return {
      page_loaded: false,
      filter_dates: {
        start: moment().subtract(3, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      },
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'last3Days', label: 'Last 3 days', value: 3 },
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last14Days', label: 'Last 14 days', value: 14 },
      ],
      account_data: {},
      paymentForm: {},
      serviceForm: {},
      transactionItems: [],
      isSubmittingPaymentForm: false,
      isSubmittingServiceForm: false,
      transaction_categories_options: [],
      currency_options: [
        {code: 'USD', name: 'US Dollars'},
        {code: 'TZS', name: 'Tanzanian Shillings'},
        {code: 'EUR', name: 'Euro'},
      ],
      method_options: [
        {code: 'cash', name: 'Cash'},
        {code: 'card', name: 'Credit Card'},
        {code: 'lipa', name: 'LIPA'},
      ],
    }
  },
  validations: {
    paymentForm: {
      method: {required},
      amount: {required},
      currency: {
        required: requiredIf(function() {
          return this.paymentForm?.method === 'cash'
        })
      },
    },
    serviceForm: {
      transaction_category: {required},
      amount: {required},
      notes: {
        required: requiredIf(function() {
          return this.serviceForm?.transaction_category?.notes_required
        })
      },
    }
  },
  created() {
    getHotelManagementHouseAccountsV2Detail(this.$route.params.id)
      .then(res => {
        this.account_data = res.data
        this.fetchTransactions()
      })
  },
  methods: {
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchTransactions()
      } else this.date_picker_error = true
    },
    async fetchTransactions() {
      const response = await getHotelManagementTransactions({
        house_account: Number(this.$route.params.id),
        from_date: this.filter_dates?.start,
        to_date: this.filter_dates?.end,
      })
      this.transactionItems = response.data
      this.page_loaded = true
    },
    onCheckForm(form, action) {
      this.$v[form].$touch()
      if (this.$v[form].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this[action]()
      }
    },
    onCreatePayment() {
      this.isSubmittingPaymentForm = true
      const data = {...this.paymentForm, house_account: Number(this.$route.params.id)}
      if (this.paymentForm?.method !== 'cash') delete this.paymentForm.currency
      postHotelManagementPaymentsCreateSingle(data)
        .finally(() => {
          this.isSubmittingPaymentForm = false
        })
        .then(() => {
          this.fetchTransactions()
          this.$modal.hide('payment-form')
        })
    },
    onCreateService() {
      this.isSubmittingServiceForm = true
      const data = {
        ...this.serviceForm,
        transaction_category: this.serviceForm.transaction_category.code,
        house_account: Number(this.$route.params.id),
      }
      postHotelManagementTransactions(data)
        .finally(() => {
          this.isSubmittingServiceForm = false
        })
        .then(() => {
          this.fetchTransactions()
          this.$modal.hide('service-form')
        })
    },
    onVoidTransaction() {
      this.fetchTransactions()
    },
    onShowModalPayment() {
      this.paymentForm = {}
      this.$v.paymentForm.$reset()
      this.$modal.show('payment-form')
    },
    onShowModalService() {
      getHotelManagementTransactionCategories({debit: true})
        .then(response => {
          this.transaction_categories_options = response.data
          this.serviceForm = {}
          this.$v.serviceForm.$reset()
          this.$modal.show('service-form')
        })
    },
  }
}
</script>

<style>
.hm-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
}

.hm-heading__title {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.1;
}

.hm-heading__id {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.1;
}

.hm-folio__balance {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 40px;
  padding: 0 16px;
  border-radius: 7px;
  background-color: #F6F6F6;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.hm-gridline {
  display: grid;
  grid-template-columns: 120px 120px 240px;
  gap: 15px;
  margin-bottom: 30px;
}
</style>